// extracted by mini-css-extract-plugin
export var container = "DropDownMenu-module--container--021d2";
export var ctaButton = "DropDownMenu-module--ctaButton--370d8";
export var divider = "DropDownMenu-module--divider--05eb0";
export var dropdownMenuButton = "DropDownMenu-module--dropdownMenuButton--3ecac";
export var entriesContainer = "DropDownMenu-module--entriesContainer--de267";